import {useReducer} from 'react';
import { onRule } from "../../../../../components/UI/PopUp/withoutSms"

import formActions from "./actions"

import axios from "axios"

import {
    validateName,
    validatePhoneNumber,
    transformPhoneAfterMask
  } from "./validation";
import {getUrlParams} from './params';

const {
    START_FETCH,
    FINISH_FETCH,
    FETCH_SUCCESS,
    FETCH_FAIL,
    CHANGE_NAME,
    VALID_NAME,
    CHANGE_PHONE,
    VALID_PHONE,
    CHECKED_NAME,
    CHECKED_PHONE,
    TOGGLE_RULE,
  } = formActions

const initialState = {
    fetch: false,
    success: false,
    fail: false,
    name: { valid: false, value: "", checked: false },
    phone: { valid: false, value: "", checked: false },
    rule: true,
}

const checkChannel = () => {
  const { utm_source } = getUrlParams()
  //console.log("utm_source", utm_source)

  return utm_source
}

const checkMedium = () => {
  const { utm_medium } = getUrlParams()
  //console.log("utm_medium", utm_medium)

  return utm_medium
}

const checkСampaign = () => {
  const { utm_campaign } = getUrlParams()
  //console.log("utm_campaign", utm_campaign)

  return utm_campaign
}


const checkСontent = () => {
  const { utm_content } = getUrlParams()
  //console.log("utm_campaign", utm_campaign)

  return utm_content
}

const reducer = (state, action) => {
    switch (action.type) {
        case START_FETCH:
        return { ...state, fetch: true }
        case FINISH_FETCH:
        return { ...state, ...initialState }
        case FETCH_SUCCESS:
        return { ...state, fetch: false, success: true }
        case FETCH_FAIL:
        return { ...state, fetch: false, fail: true }

        case CHANGE_NAME:
        return { ...state, name: { ...state.name, value: action.payload } }
        case VALID_NAME:
        return {
            ...state,
            name: { ...state.name, valid: action.payload },
        }

        case CHECKED_NAME:
        return { ...state, name: { ...state.name, checked: true } }
        case CHECKED_PHONE:
        return { ...state, phone: { ...state.phone, checked: true } }

        case CHANGE_PHONE:
        return { ...state, phone: { ...state.phone, value: action.payload } }
        case VALID_PHONE:
        return {
            ...state,
            phone: { ...state.phone, valid: action.payload },
        }
        case TOGGLE_RULE:
        return {
            ...state,
            rule: !state.rule,
        }

        default:
        return state
    }
    }
  
const useForm = link => {
    const [state, dispatch] = useReducer(reducer, initialState)

    //UI
    const startFetch = () => dispatch({ type: START_FETCH })
    const finishFetch = () => dispatch({ type: FINISH_FETCH })
    const fetchSuccess = () => dispatch({ type: FETCH_SUCCESS })
    const fetchFail = () => dispatch({ type: FETCH_FAIL })

    const toggleRule = () => dispatch({ type: TOGGLE_RULE })

    //Name
    const checkedName = () => dispatch({ type: CHECKED_NAME })

    const validName = isValidName =>
        dispatch({ type: VALID_NAME, payload: isValidName })
    const changeName = name => {
        dispatch({ type: CHANGE_NAME, payload: name })
        const isValidName = validateName(name)

        validName(isValidName)
    }

    //Phone
    const checkedPhone = () => dispatch({ type: CHECKED_PHONE })

    const validPhone = isValidPhone =>
        dispatch({ type: VALID_PHONE, payload: isValidPhone })
    const changePhone = phone => {
        dispatch({ type: CHANGE_PHONE, payload: phone })
        const normalPhone = transformPhoneAfterMask(phone)

        const isValidPhone = validatePhoneNumber(normalPhone)
        validPhone(isValidPhone)
    }

    const onSend = async () => {
        
        try {
          const { phone, inn, name, rule } = state
    
          ///Transform form after mask
          const normalPhone = transformPhoneAfterMask(phone.value)
    
          //Validate fileds
          const isValidPhone = validatePhoneNumber(normalPhone)
          const isValidName = validateName(name.value)
    
          checkedPhone()
          checkedName()
    
          //Set fields
          validPhone(isValidPhone)
          validName(isValidName)
 
          if (isValidPhone && isValidName) {
            if (!rule) {
              onRule()
              return
            }
            startFetch()
            const utmSource = checkChannel();
            const utmMedium = checkMedium();
            const utmСampaign = checkСampaign();
            const utmContent = checkСontent();
            try {
              const res = await axios.post("https://refinance.tascombank.ua/api/corpsite", {
                name: name.value,
                phone: normalPhone,
                product_id: "50",
                inn: '0000000000',
                city: 'No city',
                email: 'deposit@tascombank.ua',
                utm_content: utmContent ? utmContent : 'landing'
              })
    
              //console.log(res)
              res.status === 201 || res.status == 200 ? fetchSuccess() : fetchFail()
            } catch (error) {
              console.log("error", error)
              fetchFail()
            } finally {
              finishFetch()
              return
            }
          }
        } catch (error) {
          console.log("err", error)
        }
      }
    
      return {
        state,
    
        changeName,
        checkedName,
        toggleRule,
        checkedPhone,
        changePhone,
        onSend,
      }

}

export default useForm